// extracted by mini-css-extract-plugin
export default {"termsOfService":"Terms_termsOfService__YYzHY","popIn":"Terms_popIn__ahLmb","termsOfServiceInner":"Terms_termsOfServiceInner__AbBC7","closeTerms":"Terms_closeTerms__q8A9d"};